import axios from 'axios'


export const EventAPI = function () {
  const eventAPI_URL = "https://kitchenservice-de.herokuapp.com/event";
  //const eventAPI_URL = "http://localhost:3000/event";

  const dispatch = async function(eventID, payload) {
    if (typeof(eventID) != 'string') {
      throw Error(
        "EventAPI.dispatch: Id has to be a string but is of type '"+
        typeof(eventID)+"'"
      );
    }
    if ((typeof(payload) == 'undefined') || (payload === null)) {
      throw Error(
        "EventAPI.dispatch: Payload is not defined or null and of type '"+
        typeof(payload)+"'"
      ); 
    }
    const request = {
      url: eventAPI_URL + "/add",
      body: {
        eventID: eventID,
        payload: payload
      }
    }
    // Axios just throws when the return status is not 200/OK
    await axios.post(
      request.url,
      request.body
    ); 
  }

  const setup = async function() {
    await axios.get(
      eventAPI_URL,
      {}
    ); 
  }

  return {
    dispatch,
    setup
  }
};
export const eventSystem = EventAPI();